import { ElementRef } from '@angular/core';


export class NavItem {

    link: string;

    content: ElementRef;
}
